import { delay, takeLatest, put, all } from 'redux-saga/effects'
import types from '../actions/types'
import { generalError } from 'actions/index'

export default () => {
  function * handleInvalidForm () {
    try {
      yield put({ type: types.DIRTY_HIDE_PROMPT })
      yield put({ type: types.DIRTY_SET_FORM_VALID, isFormValid: false })
      yield delay(200)
      yield put({ type: types.DIRTY_SHOW_PROMPT })
    } catch (e) {
      console.error(e)
      yield put(generalError())
    }
  }
  function * watcher () {
    yield all([
      takeLatest(types.DIRTY_FORM_IS_INVALID, handleInvalidForm),
    ])
  }

  return {
    watcher,
  }
}
